import { render, staticRenderFns } from "./home-who.vue?vue&type=template&id=be387e24"
import script from "./home-who.vue?vue&type=script&lang=js"
export * from "./home-who.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports